<template>
  <v-card flat>
    <v-toolbar color="cyan darken-1" small dark>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-card class="mb-5">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" class="specific">
              <v-select
                v-model="form.anneeDocuments"
                :items="bilans"
                small-chips
                multiple
                :label="$t('document.list.headers.bilans')"
                filled
                background-color=""
                required
                hide-details
                class="custom-select"
                :error="$v && $v.form.anneeDocuments.$invalid"
                @change="searchByBilan"
              >
                <template #prepend-item>
                  <v-list-item ripple @click="toggleBilans">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          form.anneeDocuments.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                      >
                        {{ iconBilan }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('document.list.headers.selectAll') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template #append-item>
                  <v-divider class="mb-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="form.typesDocuments"
                :items="enums.typeDocument"
                item-text="label"
                item-value="id"
                small-chips
                multiple
                :label="$t('document.list.headers.typeDocumentSearch')"
                filled
                background-color=""
                required
                hide-details
                class="custom-select"
                :error="$v && $v.form.typesDocuments.$invalid"
                @change="searchByTypesDocuments"
              >
                <template #prepend-item>
                  <v-list-item ripple @click="toggleTypesDocuments">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          form.typesDocuments.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                      >
                        {{ iconTypeDocument }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('document.list.headers.selectAll') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template #append-item>
                  <v-divider class="mb-2"></v-divider>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="mt-5">
        <v-container fluid>
          <datasource-table
            ref="dataTable"
            v-model="documentsSelected"
            :datasource="datasource"
            :expanded.sync="expanded"
            @item-selected="selectItem"
          >
            <template #[`header.data-table-select`]>
              <v-simple-checkbox
                v-model="selectAll"
                hide-details
                :indeterminate="indeterminate"
              ></v-simple-checkbox>
            </template>
            <template #[`expanded-item`]="{ item }">
              <td class="py-2 px-2" :colspan="headers.length + 2">
                <v-data-table
                  v-model="documentsSelected"
                  :headers="headers"
                  :items="documentsJoints(item)"
                  elevation="0"
                  show-select
                  hide-default-footer
                  hide-default-header
                >
                  <template #[`item.dateCreation`]="{ item }">
                    <td>{{ formatDate(item.dateCreation) }}</td>
                  </template>
                  <template #[`item.typeDocument`]="{ item }">
                    {{ item.typeDocument.label }}
                  </template>
                  <template #[`item.nomDocument`]="{ item }">
                    {{
                      item.modeAffichageNomDocument
                        ? item.modeAffichageNomDocument === 'INFO_DOCUMENT'
                          ? item.libelleDocument
                          : item.nomDocument
                        : item.typeDocument.modeAffichageNomDocument ===
                            'INFO_DOCUMENT'
                          ? item.libelleDocument
                          : item.nomDocument
                    }}
                  </template>
                  <template #[`item.download`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedItemTraitements(item)"
                          >mdi-eye-circle</v-icon
                        >
                      </template>
                      <span>{{ $t('document.list.eyeHover') }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedItemTraitements(item, true)"
                          >mdi-download-circle</v-icon
                        >
                      </template>
                      <span>{{ $t('document.list.downloadHover') }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </td>
            </template>
            <template
              #[`item.data-table-expand`]="{ item, isExpanded, expand }"
            >
              <div
                v-if="
                  item?.documentJointExtraciem?.length ||
                  item?.documentJointLSExtraciem?.length
                "
              >
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      :class="{
                        'v-data-table__expand-icon': true,
                        'v-data-table__expand-icon--active': isExpanded,
                      }"
                      @click="expand(!isExpanded)"
                      v-on="on"
                    >
                      mdi-chevron-down-circle
                    </v-icon>
                  </template>
                  <span>{{ $t('document.list.expandHover') }}</span>
                </v-tooltip>
              </div>
            </template>
            <template #[`item.dateCreation`]="{ item }">
              {{ formatDate(item.dateCreation) }}
            </template>
            <template #[`item.typeDocument`]="{ item }">
              {{ item.typeDocument.label }}
            </template>
            <template #[`item.nomDocument`]="{ item }">
              {{
                item.modeAffichageNomDocument
                  ? item.modeAffichageNomDocument === 'INFO_DOCUMENT'
                    ? item.libelleDocument
                    : item.nomDocument
                  : item.typeDocument.modeAffichageNomDocument ===
                      'INFO_DOCUMENT'
                    ? item.libelleDocument
                    : item.nomDocument
              }}
            </template>
            <template #[`item.download`]="{ item }">
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="selectedItemTraitements(item)"
                    >mdi-eye-circle</v-icon
                  >
                </template>
                <span>{{ $t('document.list.eyeHover') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="selectedItemTraitements(item, true)"
                    >mdi-download-circle</v-icon
                  >
                </template>
                <span>{{ $t('document.list.downloadHover') }}</span>
              </v-tooltip>
            </template>
          </datasource-table>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                :disabled="documentsSelected.length === 0"
                @click="dialogSendDocuments = true"
                >{{ $t('button.send') }}</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card-text>

    <v-dialog v-model="visualisePDF" scrollable max-width="100%">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ currentDocument.fileName }}
          <v-spacer></v-spacer>
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-title>

        <v-card-text style="height: 600em">
          <vue-pdf-app
            :pdf="currentDocument.contentDocument"
            :file-name="currentDocument.fileName"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSendDocuments" persistent width="60vw">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ $t('document.send.title') }}
        </v-card-title>

        <v-card-text class="body-1">
          <v-form>
            <v-layout row mt-5 mr-0 ml-0>
              <v-flex md6 class="flex-end">
                {{ $t('document.send.dialog.mail') }}
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model="formDocument.mail"
                  :label="$t('document.send.input.mail')"
                  :error-messages="$errors($v.formDocument.mail)"
                  :disabled="formDocument.myselft"
                  autocomplete="off"
                />
              </v-flex>
            </v-layout>
            <v-layout row mt-5 mr-0 ml-0 class="flex-end">
              <v-checkbox
                v-model="formDocument.myselft"
                :label="$t('document.send.input.myself')"
                @change="toggleMail"
              ></v-checkbox>
            </v-layout>
            <v-layout row mt-5 mr-0 ml-0>
              <v-flex md6 class="flex-end">
                {{ $t('document.send.dialog.password') }}
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model="formDocument.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('document.send.input.password')"
                  :error-messages="$errors($v.formDocument.password)"
                  @click:append="showPassword = !showPassword"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-label>
            {{ $t('document.send.dialog.data') }}
          </v-label>
          <v-btn
            color="primary"
            :disabled="$v.formDocument.$invalid"
            :loading="envoiDocs"
            @click="sendDocuments()"
          >
            {{ $t('button.send') }}
          </v-btn>
          <v-btn @click="cancelSendDocument()">
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource'
import moment from 'moment'
import Api from '@/utils/api'
import toasted from '@/utils/toasted'
import VuePdfApp from 'vue-pdf-app'
import { getter } from '@/utils/store'
// import this to use default icons for buttons
import 'vue-pdf-app/dist/icons/main.css'
import { required, email } from 'vuelidate/lib/validators'
import _ from 'lodash'
import { detectFileType, base64ToByteArray } from '@/utils/document'

const ANNEXES_CAT = 'CONS_MEDICAL'

export default {
  components: {
    VuePdfApp,
  },
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    capabilities: {
      type: String,
      default: '',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
    categorie: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  data() {
    const fields = [
      // ...this.fieldName,
      {
        value: 'dateCreation',
        sortable: true,
      },
      {
        value: 'typeDocument',
        sortable: true,
      },
      {
        value: 'nomDocument',
        sortable: true,
      },
      {
        value: 'download',
        text: this.$t('accueil.documents.headers.download'),
        particular: true,
        sortable: false,
      },
    ]
    if (this.categorie === ANNEXES_CAT) {
      fields.push({
        value: 'data-table-expand',
        text: this.$t('accueil.documents.headers.annexes'),
        sortable: false,
      })
    }
    const datasource = new Datasource('document/list', {
      page: 1,
      rowsPerPage: 20,
      sortBy: 'dateCreation',
      descending: true,
      labelNamespace: 'document.list',
      showSelect: true,
      showExpand: true,
      noDataText: this.$t('document.list.noDataText'),
      args: {
        actif: true,
      },
      fields,
    })
    return {
      expanded: [],
      enums: {
        typeDocument: [],
        dates: [],
      },
      bilans: [],
      mail: null,
      datasource,
      documentsSelected: [],
      form: {
        anneeDocuments: [],
        typesDocuments: [],
      },
      visualisePDF: false,
      dialogSendDocuments: false,
      currentDocument: {
        contentDocument: null,
        fileName: null,
      },
      headers: fields,
      showPassword: false,
      envoiDocs: false,
      formDocument: {
        mail: null,
        password: null,
        myselft: false,
      },
    }
  },
  computed: {
    choiceAllBilans() {
      return this.form.anneeDocuments.length === this.bilans.length
    },
    choiceSomeBilans() {
      return this.form.anneeDocuments.length > 0 && !this.choiceAllBilans
    },
    iconBilan() {
      if (this.choiceAllBilans) return 'mdi-close-box'
      if (this.choiceSomeBilans) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    choiceAllTypesDocuments() {
      return this.form.typesDocuments.length === this.enums.typeDocument.length
    },
    choiceSomeTypesDocuments() {
      return (
        this.form.typesDocuments.length > 0 && !this.choiceAllTypesDocuments
      )
    },
    iconTypeDocument() {
      if (this.choiceAllTypesDocuments) return 'mdi-close-box'
      if (this.choiceSomeTypesDocuments) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAll: {
      get() {
        const allSelected =
          this.documentsSelected.length === this.toutDocumentsEtJoints.length
        const noneSelected = this.documentsSelected.length === 0
        return (
          this.documentsSelected.length > 0 && (allSelected || noneSelected)
        )
      },
      set(value) {
        if (value) {
          this.toggleSelectAll(true)
        } else {
          this.toggleSelectAll(false)
        }
      },
    },
    indeterminate() {
      return !this.selectAll && this.documentsSelected?.length > 0
    },
    toutDocumentsEtJoints() {
      let docs = [...this.datasource.items]
      ;(this.datasource?.items || []).forEach((doc) => {
        docs = docs.concat(
          this.documentsJoints(doc).filter((doc) => doc.isSelectable),
        )
      })
      return docs
    },
  },
  watch: {
    categorie(val) {
      this.enums.typeDocument = []
      this.datasource.args['categorieExtraciem'] = val
      this.refreshTable()
    },
  },
  beforeCreate() {
    new Api('abstractenum/typedocument/' + this.$route.params.categorie)
      .get()
      .then((response) => {
        if (response && response.body) {
          this.loadEnum(response.body)
        }
      })
      .catch((error) => {
        try {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.typedocument')
          }
        } catch (err) {
          console.log('')
        }
      })

    new Api('annees-bilans')
      .get()
      .then((response) => {
        if (response && response.body) {
          this.loadBilans(response.body)
        }
      })
      .catch((error) => {
        try {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.bilans')
          }
        } catch (err) {
          console.log('')
        }
      })

    // let idTechnique = getter('oauth/idTechnique');
    new Api('mail')
      .get()
      .then((response) => {
        if (!response.bodyText) {
          toasted.error('document.error.mail')
        }
        this.mail = response.bodyText
      })
      .catch((error) => {
        try {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.mail')
          }
        } catch (err) {
          console.log('')
        }
      })
  },
  mounted() {
    this.$nextTick(function () {
      this.datasource.args['categorieExtraciem'] = this.categorie
      if (this.$v) {
        this.$v.form.$touch()
        this.$v.formDocument.$touch()
      }
    })
  },
  methods: {
    selectItem(event) {
      if (event.value) {
        this.documentsSelected.push(event.item)
      } else {
        this.documentsSelected = this.documentsSelected.filter(
          (doc) => doc.id !== event.item.id,
        )
      }
    },
    documentsJoints(doc) {
      const joints = (doc?.documentJointExtraciem || []).map((doc) => {
        return { ...doc, isSelectable: true }
      })
      const documentJointLS = (doc?.documentJointLSExtraciem || []).map(
        (doc) => {
          return { ...doc, isSelectable: false }
        },
      )
      return joints.concat(documentJointLS)
    },
    toggleSelectAll(value) {
      if (value) {
        this.documentsSelected = this.toutDocumentsEtJoints
      } else {
        this.documentsSelected = []
      }
    },
    refreshTable() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.datasource.refresh()
      } else {
        this.datasource.items = []
      }
    },
    selectedItemTraitements(item, download) {
      this.$api(
        `document/${item.id}/${item.isSelectable === false ? 'ls/' : ''}`,
      )
        .get()
        .then((response) => {
          const byteArray = base64ToByteArray(response.body.bytes)
          const formatDocument = detectFileType(byteArray)
          if (download) {
            this.download(response.body, formatDocument)
          } else {
            if (formatDocument === 'jpg' || formatDocument === 'png') {
              this.previewImage(byteArray, formatDocument)
            } else {
              this.previewPDF(response.body)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.selectdocument')
          }
        })
    },

    loadEnum(loaded) {
      if (loaded != null) {
        this.enums.typeDocument = loaded
      }
      this.enums.dates = this.generateEnumAfterDate()
    },
    loadBilans(loaded) {
      if (loaded != null) {
        this.bilans = loaded
      }
    },

    generateEnumAfterDate() {
      var dates = []
      dates.push({
        label: this.$t('document.list.enums.age.onemonth'),
        date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.threemonths'),
        date: moment().subtract(3, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.sixmonths'),
        date: moment().subtract(6, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.heightmonths'),
        date: moment().subtract(8, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.oneyear'),
        date: moment().subtract(12, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.twoyears'),
        date: moment().subtract(24, 'months').format('YYYY-MM-DD'),
      })
      dates.push({
        label: this.$t('document.list.enums.age.threeyears'),
        date: moment().subtract(36, 'months').format('YYYY-MM-DD'),
      })

      return dates
    },

    extractDocument(document) {
      const binaryString = window.atob(document.bytes) // Comment this if not using base64
      const bytes = new Uint8Array(binaryString.length)
      return bytes.map((byte, i) => binaryString.charCodeAt(i))
    },

    previewPDF(document) {
      if (document) {
        const mappedData = this.extractDocument(document)
        this.currentDocument.contentDocument = mappedData.buffer
        this.currentDocument.fileName = document.document.nomDocument
        this.visualisePDF = true
      }
    },
    previewImage(byteArray, documentType) {
      var blob = new Blob([byteArray], { type: `application/${documentType}` })
      console.log(window.URL.createObjectURL(blob))
      this.$viewerApi({
        options: {
          toolbar: false,
        },
        images: [window.URL.createObjectURL(blob)],
      })
    },
    download(doc, documentType) {
      if (doc) {
        const mappedData = this.extractDocument(doc)
        var blob = new Blob([mappedData], {
          type: `application/${documentType}`,
        })
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          doc.document.nomDocument.replace('PDF', documentType),
        ) // Nom du fichier de téléchargement
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    },

    resetFormDocument() {
      this.formDocument.mail = null
      this.formDocument.myselft = false
      this.formDocument.password = null
    },

    cancelSendDocument() {
      this.dialogSendDocuments = false
      this.resetFormDocument()
    },

    sendDocuments() {
      this.envoiDocs = true
      toasted.info('document.send.enCours')
      const input = {
        mail: this.formDocument.mail,
        password: this.formDocument.password,
        idDocuments: this.documentsSelected.map((doc) => doc.id),
      }
      this.$api('document/download')
        .post(input)
        .then((response) => {
          if (
            response &&
            response.body &&
            response.body.ciemException &&
            !_.isEmpty(response.body.ciemException.messages)
          ) {
            response.body.ciemException.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                toasted.error(this.$t(m.errorCode))
              } else if (m.level == 'WARN') {
                toasted.warning(this.$t(m.errorCode))
              } else if (m.level == 'INFO') {
                toasted.info(this.$t(m.errorCode))
              }
            })
          }
          toasted.success('document.send.success')
        })
        .catch((error) => {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.sendDocument')
          }
        })
        .finally(() => {
          this.dialogSendDocuments = false
          this.envoiDocs = false
          this.resetFormDocument()
          this.documentsSelected = []
        })
    },

    toggleMail(event) {
      if (event) {
        this.formDocument.mail = this.mail
      } else {
        this.formDocument.mail = null
      }
    },

    toggleSelect(event) {
      if (event.value) {
        this.documentsSelected = event.items
      } else {
        this.documentsSelected = []
      }
    },

    toggleBilans() {
      this.$nextTick(() => {
        if (this.choiceAllBilans) {
          this.form.anneeDocuments = []
        } else {
          this.form.anneeDocuments = this.bilans.slice()
        }
        this.searchByBilan()
      })
    },

    toggleTypesDocuments() {
      this.$nextTick(() => {
        if (this.choiceAllTypesDocuments) {
          this.form.typesDocuments = []
        } else {
          this.form.typesDocuments = this.enums.typeDocument
            .map((t) => t.id)
            .slice()
        }
        this.searchByTypesDocuments()
      })
    },

    searchByBilan() {
      this.datasource.args['anneeDocuments'] = JSON.stringify(
        this.form.anneeDocuments,
      )
      this.refreshTable()
    },
    searchByTypesDocuments() {
      this.datasource.args['typesDocuments'] = JSON.stringify(
        this.form.typesDocuments,
      )
      this.refreshTable()
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
  },
  validations() {
    return {
      form: {
        anneeDocuments: { required },
        typesDocuments: { required },
      },
      formDocument: {
        mail: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    }
  },
}
</script>

<style scoped>
.layout {
  align-items: center;
}
.flex {
  padding: 5px;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  text-align: end;
}
.v-toolbar {
  max-height: 44px;
}
.v-label {
  margin-right: 10px;
}
.v-toolbar__title {
  font-size: 18px;
  margin-bottom: 15px;
}
</style>
<style>
.v-data-table__wrapper .v-simple-checkbox--disabled {
  display: none;
}

.custom-select .v-input__icon.v-input__icon--append .v-icon {
  font-size: 48px;
}

.custom-select .v-input__append-inner {
  display: flex;
  height: 100%;
  align-items: center;
}

.v-menu__content {
  max-height: 550px !important;
}
</style>
